import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Icon, Row, Tooltip, Col,Pagination} from 'antd';
import {Field, reduxForm} from "redux-form";

import Loading from '../loading/loading';

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        width:'5%'
    },
    {
        title: 'عنوان',
        dataIndex: 'title',
        width:"25%"
    },
    {
        title: 'شماره حساب',
        dataIndex: 'account_number',
        width:"15%"
    },
    {
        title: 'نام بانک',
        dataIndex: 'bank_title',
        width:"15%"
    },
    {
        title: 'موجودی (ریال)',
        dataIndex: 'balance',
        sorter: (a, b) => a.balance.length - b.balance.length,
        className:"price"
    },

  ];


class bankList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:true,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1)
        }
        this.__onChangeCounter = this.__onChangeCounter.bind(this)
    }

    componentWillMount() {
        this.props.getList();
    }

    /*--- pagination ---*/
    handlePageChange(pageNumber) {
        this.setState({current: pageNumber});
        this.props.getList({page:pageNumber});
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        var list = this.props.list;
        var dataSource = [];
        if(list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push({
                    key: i+1,
                    title : list[i].title,
                    account_number: list[i].account_number,
                    bank_title : list[i].bank_title,
                    balance : (list[i].balance).toLocaleString(navigator.language, { minimumFractionDigits: 0 })
                });
            }
        }
        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    __onChangeCounter(current, pageSize) {
        this.props.getList({size:pageSize});
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const {pageSize } = this.state;
        const { list } = this.props;

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={20}>
                        <Divider orientation="left">لیست حساب ها</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={4} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="plus" href="#/bank/add">
                            ایجاد حساب بانکی
                        </RTLButton>
                    </RTLCol>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                    بازگشت
                </RTLButton>
            </div>
        );
    }
}

export default bankList = reduxForm({
    form: 'list'
})(bankList)
